import './ReferralHeader.scss'

import React from 'react';
import ReferralContact from './ReferralContact'
import {
  ASSIGNMENT_AGENT_STATUS,
  ASSIGNMENT_AGENT_STATUS_LISTING,
  ASSIGNMENT_AGENT_STATUS_LEASE,
  BUYER_TYPE,
} from 'common/constants'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { labelFor } from 'common/util/helper'
import { push } from 'react-router-redux'
import {
  selectReferralIsTransition,
  selectReferralTags,
} from 'manager/selectors/referral_selectors'
import { VIPBadge } from 'manager/views/components/Referral/ReferralBadge'
import marketVIPIcon from '../../../../images/market-vip.svg'

const ReferralHeaderComp = (props) => {

  const {
    canUseInbox,
    canUseVoip,
    dispatch,
    isTransition,
    params,
    referral = {},
    route,
  } = props

  const {
    agent_status,
    is_lease,
    transaction_type,
    client_category,
    agent_hold_until,
    name,
    phone,
    email,
  } = referral

  const handleClick = () => {
    dispatch(push({
      pathname:`/referral/${params.hash}`,
      query:{contact: true}
    }))
  }

  let isNewTransaction = route.path === 'add'

  let agentStatus
  if (is_lease) {
    agentStatus = labelFor(ASSIGNMENT_AGENT_STATUS_LEASE, agent_status)
  } else {
    agentStatus = transaction_type === 'list' ? labelFor(ASSIGNMENT_AGENT_STATUS_LISTING, agent_status) : labelFor(ASSIGNMENT_AGENT_STATUS, agent_status)
  }
  agentStatus = isNewTransaction ? "New" : agentStatus

  const isEmailValid = email ? !email.match('Declined email') : false

  return (
    <div className="ReferralHeader">
      <div className="ReferralHeader__left">
        <div className="ReferralHeader__name" onClick={handleClick}>
          {name && name.match('Declined last name') ? name.split(' ')[0] : name}
          {isTransition && <VIPBadge icon={marketVIPIcon} />}
          <i className="fa fa-pencil ReferralHeader__pencil"/>
        </div>
        <div className="ReferralHeader__phone">{phone}</div>
        { isEmailValid ? <div className="ReferralHeader__email">{email}</div> : <div className="ReferralHeader__no_email">No email provided</div> }
        <div className={"ReferralHeader__type ReferralHeader__type-" + client_category}/><span className="ReferralHeader__type-value">{ labelFor(BUYER_TYPE, client_category) }</span>
      </div>
      <div className="ReferralHeader__status">
        <div className="ReferralHeader__status__badges_container">
          <span className="ReferralHeader__status__label">Current Status</span>
          <div className="ReferralStatusBadges">
            <span className="ReferralStatusBadges__badge">
              { agentStatus }
            </span>
            {agent_hold_until && <span className="ReferralStatusBadges__badge ReferralStatusBadges__badge--holding">Long Term Hold</span>}
          </div>
        </div>
      </div>
      <div className="ReferralHeader__right">
        <ReferralContact canUseInbox={canUseInbox} canUseVoip={canUseVoip} {...props}/>
      </div>
    </div>
  )
}

const selector = createStructuredSelector({
  isTransition: selectReferralIsTransition,
  transactionTags: selectReferralTags,
})

const actions = {}

const withRedux = connect(selector, actions)

export const ReferralHeader = withRedux(ReferralHeaderComp)
